import notFound from '../pages/404/404.vue'
import healthCheck from '../pages/healthcheck/healthcheck.vue'
import installments_step from '../pages/installments/index.vue'
import promotion from '../pages/promotion/index.vue'
import promotion_check from '../pages/promotion/check.vue'

export const routes = [
  {
    path: '*',
    component: notFound,
    meta: { isAuth: false, title: `${process.env.VUE_APP_DOMAIN_TITLE} | 404` }
  },
  {
    path: '/healthcheck/liveness',
    component: healthCheck,
    meta: { isAuth: false, title: `${process.env.VUE_APP_DOMAIN_TITLE} | Health check` }
  },
  {
    path: '/healthcheck/readiness',
    component: healthCheck,
    meta: { isAuth: false, title: `${process.env.VUE_APP_DOMAIN_TITLE} | Health check` }
  },
  {
    path: '/',
    name: 'step',
    component: installments_step,
    meta: { isAuth: false, keepAlive: true, title: `${process.env.VUE_APP_DOMAIN_TITLE} | Kiểm tra thẻ trả góp`, layout: 'default' }
  },
  {
    path: '/promotion/budget',
    name: 'promotion_budget',
    component: promotion,
    meta: { isAuth: false, keepAlive: true, title: `${process.env.VUE_APP_DOMAIN_TITLE} | Thông tin ngân sách khuyến mãi`, layout: 'default' }
  },
  {
    path: '/promotion/check',
    name: 'promotion_check',
    component: promotion_check,
    meta: { isAuth: false, keepAlive: true, title: `${process.env.VUE_APP_DOMAIN_TITLE} | Kiểm tra khuyến mãi`, layout: 'default' }
  }
]
